var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1479_21409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 0H8C3.85786 0 0.5 3.35786 0.5 7.5V42.5C0.5 46.6421 3.85786 50 8 50H43C47.1421 50 50.5 46.6421 50.5 42.5V7.5C50.5 3.35786 47.1421 0 43 0Z",
    fill: "#F0DB4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1406 36.1328C33.1172 37.793 34.4844 38.9648 36.7305 38.9648C38.6836 38.9648 39.9531 37.9883 39.9531 36.6211C39.9531 35.0586 38.6836 34.4727 36.5352 33.4961L35.3633 33.0078C31.9453 31.543 29.6992 29.7852 29.6992 25.9766C29.6992 22.4609 32.3359 19.7266 36.5352 19.7266C39.5625 19.7266 41.7109 20.8008 43.1758 23.5352L39.5625 25.8789C38.7812 24.4141 37.9023 23.8281 36.5352 23.8281C35.168 23.8281 34.2891 24.707 34.2891 25.8789C34.2891 27.2461 35.168 27.832 37.2188 28.7109L38.3906 29.1992C42.3945 30.957 44.6406 32.6172 44.6406 36.6211C44.6406 40.8203 41.3203 43.1641 36.8281 43.1641C32.4336 43.1641 29.6016 41.1133 28.2344 38.3789L32.1406 36.1328ZM15.5391 36.5234C16.3203 37.793 16.9062 38.9648 18.5664 38.9648C20.1289 38.9648 21.1055 38.3789 21.1055 36.0352V19.8242H25.793V35.8398C25.793 40.7227 22.9609 42.8711 18.7617 42.8711C14.9531 42.8711 12.8047 40.918 11.7305 38.5742L15.5391 36.5234Z",
    fill: "#323330"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1479_21409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.f264fcbc00d43152bf4e07080f051412.svg";
export { ForwardRef as ReactComponent };